import { createContext } from "react";

const GlobalStateContext = createContext()

export default GlobalStateContext